import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDirection1"><Path fillRule="evenodd" clipRule="evenodd" d="M19.5 3L23.25 8L19.5 13H13V21H11V17H4.5L0.75 12L4.5 7H11V3H19.5ZM13 5V11H18.5L20.75 8L18.5 5H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirection1;
